<div class="tw-px-6 tw-py-8 tw-relative">

  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-4 tw-right-4 tw-p-[5px] tw-rounded-full" (click)="closeBottomSheet()">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-[13px] tw-h-[13px] tw-text-400 tw-leading-4 tw-text-black tw-font-bold">&#10005;</div>
  </div>

  <div class="tw-px-2">
    <div class="tw-flex tw-justify-center">
      <div class="tw-w-fit tw-relative">
        <img [src]="productImage" class="tw-w-30 tw-h-[150px] tw-object-contain tw-rounded-3" alt="product" />
        <div class="tw-absolute tw-top-[10px] tw-right-0 tw-translate-x-1/2 tw-translate-y-0">
          <img class="tw-w-[37px] tw-h-[37px]" src="/assets/images/exclamation_orange_inverted.png" alt="exclamation" />
        </div>
      </div>
    </div>
    <p class="tw-text-center tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-mt-4 tw-mb-2.5" i18n="@@notPregnancySafe">Not Pregnancy Safe</p>
    <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center">
      <span> {{data.product.title}} </span>
      <span i18n="@@containsIngredientsThatMayNotBeSafeDuringPregnancy"> contains ingredients that may not be safe during pregnancy, so we don't recommend it for you </span>
    </p>
  </div>

  <div class="tw-bg-gray-80 tw-px-4 tw-py-2.5 tw-mt-5">
    <p>
      <span class="tw-font-body tw-text-200 tw-font-bold" i18n="@@note">Note</span><span class="tw-font-body tw-text-200 tw-font-bold">:</span>&nbsp;
      <span class="tw-font-body tw-text-200" i18n="@@ifYouStillWishToBuyWeWillSendThisOrderToYourDoctor">If you still wish to buy, we will send this order to your doctor for review.</span>
    </p>
  </div>

  <div class="tw-mt-8">
    @if (data.navigateToArticlePage) {
      <button csButton
            (click)='closeBottomSheet()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@OkClose">Ok, Close</span>
      </button>
      <button csButton="muted"
              (click)='navigateToArticle()'
              class="tw-w-full tw-text-500 tw-font-semibold tw-capitalize"
              style="margin: 0 !important;">
        <span i18n="@@viewProduct">view product</span>
      </button>
    } @else {
      <button csButton
            (click)='closeBottomSheet()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@okDontAdd">Ok, Don't Add</span>
      </button>
      <button csButton="muted"
            (click)='addToCart()'
            class="tw-w-full tw-text-500 tw-font-semibold"
            style="margin: 0 !important;">
        <span i18n="@@addToCartAnyWay">Add to Cart Any Way </span>
      </button>
    }
  </div>
</div>
